import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Brochure from "./pages/Brochure";
import BrochurePDF from "./pages/BrochurePDF";

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors />
      <Routes>
        <Route path="/" element={<Brochure />} />
        <Route path="/brochure-pdf" element={<BrochurePDF />} />
        <Route path="*" element={<Brochure />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
